import { render, staticRenderFns } from "./iframe-website-creation.vue?vue&type=template&id=87839b54&scoped=true"
import script from "./iframe-website-creation.vue?vue&type=script&lang=js"
export * from "./iframe-website-creation.vue?vue&type=script&lang=js"
import style0 from "./iframe-website-creation.vue?vue&type=style&index=0&id=87839b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87839b54",
  null
  
)

export default component.exports